// extracted by mini-css-extract-plugin
module.exports = {"link":"Link_link__qt3mH","link__button":"Link_link__button__QCbuD","link__fullWidth":"Link_link__fullWidth__1mEjj"};